<div class="grid-filter-section-content">
    <button
        [attr.aria-controls]="'tray-grid-filters'"
        [attr.aria-haspopup]="'dialog'"
        [categoryInstitutional]="false"
        [hTrayOpener]="'grid-filters-tray'"
        [trayOverlay]="true"
        [trayPosition]="'right'"
        [trayTitle]="'hermes-global-translations.filter'"
        [trayNoPaddingBottom]="true"
        aria-labelledby="filter-label filter-count"
        i18n-aria-labelledby
        i18n-aria-label="@@hermes-global-translations.filter"
        id="'slider-filter-button'">
        <h-svg-icon [name]="'slider-setting'"></h-svg-icon>

        <span
            [attr.role]="'heading'"
            id="filter-label"
            aria-level="2"
            class="grid-filter-section-button-label"
            i18n="@@hermes-global-translations.filter">
            Filter
        </span>

        @if (nbFiltersSelected$ | async; as nbFiltersSelected) {

        <span id="filter-count">
            <sup>({{ nbFiltersSelected }})</sup>
            <span hSrOnlyNoSnippet i18n="@@hermes.accessibility.selected_filters">Selected filters</span>
        </span>

        }
    </button>
</div>
